import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { GetWalrProjectsQuery, IWalrClientProjectsClient, WalrClientProjectsClient } from "app/SharedApiClient";
import { LoadingState } from "types";
import { RootState } from "@store";
import { initialWalrProjectState, WalrProjectState } from "./walrProjectState";
import { CreateWalrProjectCommand, IWalrProjectsClient, WalrProjectsClient } from "app/ApiClient";

const sharedApiProjectsClient: IWalrClientProjectsClient = new WalrClientProjectsClient(process.env.REACT_APP_SHARED_API_URL);
const walrProjectsClient: IWalrProjectsClient = new WalrProjectsClient(process.env.REACT_APP_API_URL);

export const getAllWalrProjects = createAsyncThunk(
    "walrProject/getProjects",
    async () => {
      const query: GetWalrProjectsQuery = {};
      const result = await sharedApiProjectsClient.getProjects(query);      
      return result;
    },
  );

export const getWalrDatasetByProjectId = createAsyncThunk(
  "walrProject/getWalrDatasetByProjectId",
  async (projectId: string) => {
    if(projectId === "")
      return [];    
    const result = await sharedApiProjectsClient.getDatasetsByProjectID(projectId);
    return result;
  },
);

export const createWalrDataProject = createAsyncThunk(
  "createWalrProject/createWalrProject",
  async (data: CreateWalrProjectCommand, { rejectWithValue }) => {
    try {
      const response = await walrProjectsClient.createWalrProject({ ...data });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

  const walrProjectSlice = createSlice({
    name: "walrProject",
    initialState: initialWalrProjectState,
    reducers: {
        resetWalrProject: () => ({ ...initialWalrProjectState}),
        resetCreateWalrDataProjectState: (state) => {
          state.createWalrDataProjectState = LoadingState.idle;
        },
    },
    extraReducers: (builder) => {
      builder.addCase(createWalrDataProject.pending, (state) => {
          state.createWalrDataProjectState = LoadingState.pending;
          state.createWalrProject = undefined;
        });
        builder.addCase(createWalrDataProject.fulfilled, (state, { payload }) => {
          state.createWalrDataProjectState = LoadingState.succeed;
          state.createWalrProject = payload;
        });
        builder.addCase(createWalrDataProject.rejected, (state) => {
          state.createWalrDataProjectState = LoadingState.failed;
        });        
      builder.addCase(getAllWalrProjects.pending, (state) => {
        state.data = null;
        state.loading = LoadingState.idle;
      });
      builder.addCase(getAllWalrProjects.fulfilled, (state, { payload }) => {
        state.data = payload ?? [];
        state.loading = LoadingState.succeed;
      });
      builder.addCase(getAllWalrProjects.rejected, (state) => {
        state.data = null;
        state.loading = LoadingState.failed;
      });

      builder.addCase(getWalrDatasetByProjectId.pending, (state, { meta: { arg: projectId}}) => {
        state.projectDatasets = null;
        state.getDatasetsLoadingState = LoadingState.idle;
        state.projectId = projectId;
      });
      builder.addCase(getWalrDatasetByProjectId.fulfilled, (state, { payload }) => {        
        state.projectDatasets = payload ?? [];
        state.getDatasetsLoadingState = LoadingState.succeed;
      });
      builder.addCase(getWalrDatasetByProjectId.rejected, (state) => {
        state.projectDatasets = null;
        state.getDatasetsLoadingState = LoadingState.failed;
      });
    },
  });

  export const { resetWalrProject,
    resetCreateWalrDataProjectState
   } = walrProjectSlice.actions;

  export const walrSelector = (state: RootState): WalrProjectState => state.walrProject;

  export default walrProjectSlice.reducer;
  
